import React from 'react';
import { useNavigate } from 'react-router-dom';
import BulkPaymentDetails from './bulk-payment-details.jsx';

const BulkPaymentDetailsPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 12 }}>
      <BulkPaymentDetails onBack={() => navigate('/documents/bulk/proposer-details')} />
    </div>
  );
};

export default BulkPaymentDetailsPage;
